import(/* webpackMode: "eager" */ "/vercel/path0/ui/app/scenarios/page.tsx");
